import moment from 'moment'

type DateInput = string | Date | moment.Moment | null | undefined

function toMoment(value: DateInput): moment.Moment | null {
  if (!value) return null
  const m = moment(value)
  return m.isValid() ? m : null
}

export function formatDate(value: DateInput, format = 'YYYY/MM/DD'): string {
  const m = toMoment(value)
  return m ? m.format(format) : (value ? String(value) : '')
}

export function formatDateTime(value: DateInput, format = 'YYYY/MM/DD HH:mm'): string {
  const m = toMoment(value)
  return m ? m.format(format) : (value ? String(value) : '')
}

export function formatDateTimeFull(value: DateInput, format = 'YYYY/MM/DD HH:mm:ss'): string {
  const m = toMoment(value)
  return m ? m.format(format) : (value ? String(value) : '')
}

export function toISODate(value: DateInput): string {
  const m = toMoment(value)
  return m ? m.format('YYYY-MM-DD') : ''
}

export function toISODateTime(value: DateInput): string {
  const m = toMoment(value)
  return m ? m.toISOString() : ''
}

export function isValidDate(value: string): boolean {
  return moment(value).isValid()
}

export function relativeTime(value: DateInput): string {
  const m = toMoment(value)
  return m ? m.fromNow() : ''
}

export function diffDays(from: DateInput, to: DateInput): number {
  const mFrom = toMoment(from)
  const mTo = toMoment(to)
  if (!mFrom || !mTo) return 0
  return mTo.diff(mFrom, 'days')
}

export function startOfDay(value: DateInput): moment.Moment | null {
  const m = toMoment(value)
  return m ? m.startOf('day') : null
}

export function endOfDay(value: DateInput): moment.Moment | null {
  const m = toMoment(value)
  return m ? m.endOf('day') : null
}

export function now(): moment.Moment {
  return moment()
}

export { moment }
